import {
  type ClientTrainingProgram,
  type ClientTrainingProgramDetails,
} from "@fitness-app/data-models/entities/TrainingProgram";

import { type RequestStatus } from "../../../enums/requestStatus";

export const TRAINEE_PROGRAM_REDUCER_NAME = "traineeProgram";

export interface TraineeProgramReducer {
  programDetails: null | ClientTrainingProgramDetails;
  additionalProgramDetails: ClientTrainingProgramDetails[];
  programStatus: null | RequestStatus;
  programId: string | null;
  programRequestId: string | null;
  programFetchedAt: number | null;
  selectedProgram: null | ClientTrainingProgram;
  scheduledPrograms: ClientTrainingProgram[];
  /** TRE-1833 — archiwum planów w panelu trenerki, doczytywane stronami. */
  archivedPrograms: ClientTrainingProgram[];
  archivedProgramsStatus: null | RequestStatus;
  archivedProgramsHasMore: boolean;
}
